module.exports = __webpack_public_path__ + "static/media/Lifestyle_boys_dogs_pano.8045208e.jpg";